module.exports = __webpack_public_path__ + "static/media/world.f09db964.svg";